import { useTranslation } from "react-i18next";
import "../css/DeleteConfirmationDialog.css"

export const DeleteConfirmationDialog = ({ onDelete, onCancel, message }) => {
  const {t} = useTranslation();
  return (
    <div className="confirm-dialog-overlay">
      <div className="confirm-dialog">
        <h5>{t("delete_modal.confirmDeletion")}</h5>
        {message || <p>{t("delete_modal.deleteConfirmationMessage")}</p>}
        <div className="confirm-dialog-buttons">
          <button className="btn btn-danger" onClick={onDelete}>
            {t("actions.delete")}
          </button>
          <button className="btn btn-outline-secondary" onClick={onCancel}>
            {t("actions.cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};
